import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H1 } from '@liveauctioneers/hammer-ui-core/text';
import { useMemo } from 'react';

import SaveSearchContainer from '@/components/SaveSearch/SaveSearchContainer';
import { SearchParams } from '@/types/SaveSearch';

import { SearchPageZeroResultsImages } from './SearchPageZeroResultsImages';

const SINGLE_SOLD_ITEM = 1;
const DOUBLE_SOLD_ITEMS = 2;

type SearchPageZeroResultsBannerProps = {
    imageUrls: string[];
    saveSearchParams: SearchParams;
    searchTerm: string;
    totalSoldItems: number;
};

export const SearchPageZeroResultsBanner = ({
    imageUrls,
    saveSearchParams,
    searchTerm,
    totalSoldItems,
}: SearchPageZeroResultsBannerProps) => {
    const { formatMessage } = useIntl();

    const imagesContainerClassName = useMemo(() => {
        let minSizes = 'desktop:min-h-[256px] desktop:min-w-[496px] smMax:min-h-[173px]';

        if (totalSoldItems === SINGLE_SOLD_ITEM) {
            minSizes = 'desktop:min-h-[256px] desktop:min-w-[256px] smMax:min-h-[173px]';
        } else if (totalSoldItems === DOUBLE_SOLD_ITEMS) {
            minSizes = 'desktop:min-h-[304px] desktop:min-w-[536px] smMax:min-h-[221px]';
        }

        return `flex ${minSizes} shrink-0 justify-center mdMin:justify-end`;
    }, [totalSoldItems]);

    return (
        <div className="-mx-sm -mt-sm mb-lg bg-background-subdued px-sm py-lg desktop:mx-0 desktop:mt-0 desktop:rounded-md desktop:border desktop:border-border-tertiary desktop:px-2xl desktop:pt-lg desktop:pb-xl smMax:mb-md">
            <div className="flex flex-col-reverse gap-lg mdMin:flex-row mdMin:items-center mdMin:gap-2xl smMax:gap-md">
                <div className="flex flex-1 flex-col items-center justify-center">
                    <H1 className="mb-xs text-center">
                        {formatMessage({ id: 'searchPage.zeroResults.title' }, { searchTerm })}
                    </H1>
                    <BodyPrimary className="text-center">
                        {formatMessage({ id: 'searchPage.zeroResults.body' }, { totalSoldItems })}
                    </BodyPrimary>
                    <SaveSearchContainer
                        className="mt-md mobile:w-full"
                        saveSearchParams={saveSearchParams}
                        small
                        tooltipPlacement="bottom"
                    />
                </div>
                <div className={imagesContainerClassName}>
                    <SearchPageZeroResultsImages imageUrls={imageUrls} />
                </div>
            </div>
        </div>
    );
};
